import React, { useState } from 'react';
import {
  Image,
  ImageBackground,
  Text as NativeText,
  StyleSheet,
  View,
} from 'react-native';
import { GradientOverlay, FormContainer, ImageWrapper, TopSection, TouchableWrapper, RightSection } from './login.style';
import Text from '../../components/text';
import Colors from '../../constants/Colors';
import TextInputComponent from '../../components/textinput/TextInputComponent';
import Button from '../../components/button/Button';
import rightImg from '../../assets/images/forgotImage.png';
import { EmailValidation, PasswordValidation } from '../../helpers/validation';
import Urls from '../../services/Urls';
import ajax, { setAuthHeaders } from '../../helpers/ajaxHelper';
import { useDispatch, useSelector } from 'react-redux';
import { saveAuthToken } from '../../redux/action/authActions';
import { ImageLogoWrapper, Container, LeftSection } from '../register/register.style';
import WebImage from '../../assets/images/Logo/HubitaWeb.png';
import MobileImage from '../../assets/images/Logo/HubitaMobile.png';

import getPlatformType from '../../helpers/helpers';
import { TouchableOpacity } from 'react-native-gesture-handler';
import Modal from 'modal-enhanced-react-native-web';
import FooterLanding from '../../components/footerComponentLanding/customFooter';
import { Header } from '../hello/header';
import MainDrawerMenu from '../hello/MainDrawer';
import { LinearGradient } from 'expo-linear-gradient';

const loginHighlights = [
  'Stay in control with all your property information in one central hub',
  'Stay compliant and organised with clear reminders and tasks',
  'Enjoy peace of mind, knowing everything is securely managed and easy to find Hubita. Landlord life. Simplified.',

];
const LoginScreen = ({ navigation }) => {
  const layoutType = getPlatformType();
  let LogoImg = layoutType != 'phone' ? WebImage : MobileImage;
  const dispatch = useDispatch();
  const userToken = useSelector((state) => state?.AppReducer?.token);
  const [openDrawer, setDrawer] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passError, setPassError] = useState('');

  const loginAPiCall = () => {
    const requestBody = {
      email: email,
      password: password,
    };
    ajax
      .post(Urls.LoginAPI, requestBody)
      .then(({ data }) => {
        if (data.status) {

          setAuthHeaders(data?.data?.token);
          dispatch(saveAuthToken(data?.data?.token, navigation));
          dispatch({ type: "RESET_STATE" })
        } else {
          // alert(data.message);
        }
      })
      .catch((error) => {
        console.log('error', error);
      });
  };
  const _onLogin = () => {
    let emailValidate = EmailValidation(email);
    let passwordValidate = PasswordValidation(password);
    if (emailValidate.status && passwordValidate.status) {
      loginAPiCall();
    } else {
      setEmailError(emailValidate?.status ? '' : emailValidate?.msg);
      setPassError(passwordValidate?.status ? '' : passwordValidate?.msg);
    }
  };

  const publicLoginContent =
    layoutType === 'phone' ? (
      <View style={styles.mobilePublicWrap}>
        <View style={styles.mobileFormCard}>
          <NativeText style={[styles.publicTitle, styles.mobilePublicTitle]}>
            Login to your existing account
          </NativeText>
          <NativeText style={[styles.publicSubtitle, styles.mobilePublicSubtitle]}>
            Manage your rental workflow.
          </NativeText>

          <View style={[styles.formFieldSpace, styles.mobileInputBlock]}>
            <TextInputComponent
              error={emailError}
              title={'Email Address'}
              onChangeText={(e) => {
                setEmail(e), setEmailError('');
              }}
              colored
            />
          </View>
          <View style={styles.formFieldSpace}>
            <TextInputComponent
              error={passError}
              password
              maxLength={30}
              title={'Password'}
              renderRightComponent={true}
              onChangeText={(e) => {
                setPassword(e), setPassError('');
              }}
              colored
            />
          </View>

          <TouchableWrapper onPress={() => navigation.navigate('ForgotPasswordScreen')} style={styles.forgotLinkWrap}>
            <Text fontSize={18} color="#6D28D9" fontWeight={450} style={styles.forgotText}>
              Forgot Password?
            </Text>
          </TouchableWrapper>

          <LinearGradient colors={['#2C8EF4', '#5C59E8']} start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} style={[styles.primaryAction, styles.primaryActionMobile]}>
            <TouchableOpacity onPress={_onLogin} style={styles.primaryActionTouch} activeOpacity={0.9}>
              <Text fontSize={16} color="#FFFFFF" style={styles.primaryActionText}>
                Login
              </Text>
            </TouchableOpacity>
          </LinearGradient>

          <TouchableOpacity onPress={() => navigation.navigate('RegisterScreen')} style={styles.mobileSecondaryAction} activeOpacity={0.9}>
            <NativeText style={styles.mobileSecondaryActionText}>Create account</NativeText>
          </TouchableOpacity>

          <View style={styles.mobileHighlightList}>
            {loginHighlights.map((item) => (
              <View key={item} style={styles.mobileHighlightItem}>
                <View style={styles.mobileHighlightDot} />
                <NativeText style={styles.mobileHighlightText}>{item}</NativeText>
              </View>
            ))}
          </View>

          <View style={styles.mobileRegisterRow}>
            <Text fontSize={15} color="#667085">Need the public page?</Text>
            <TouchableOpacity onPress={() => navigation.push('Hello')} activeOpacity={0.8}>
              <Text fontSize={15} color="#4258DB" style={styles.mobileRegisterText}>Go Home</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    ) : (
      <View style={styles.publicShell}>
        <View style={styles.publicCard}>
          <View style={styles.publicLeftPanel}>
            <View style={styles.publicFormCardInner}>
              <NativeText style={styles.publicTitle}>
                Login to your existing account
              </NativeText>
              <NativeText style={styles.publicSubtitle}>
                Manage your rental workflow.
              </NativeText>

              <View style={styles.publicInputsWrap}>
                <TextInputComponent
                  error={emailError}
                  title={'Email Address'}
                  onChangeText={(e) => {
                    setEmail(e), setEmailError('');
                  }}
                  colored
                />
                <TextInputComponent
                  error={passError}
                  password
                  maxLength={30}
                  title={'Password'}
                  renderRightComponent={true}
                  onChangeText={(e) => {
                    setPassword(e), setPassError('');
                  }}
                  colored
                />
              </View>

              <View style={styles.publicFooterRow}>
                <TouchableWrapper onPress={() => navigation.navigate('ForgotPasswordScreen')}>
                  <Text fontSize={16} color="#6D28D9" fontWeight={450} style={styles.forgotText}>
                    Forgot Password?
                  </Text>
                </TouchableWrapper>

                <LinearGradient colors={['#2C8EF4', '#5C59E8']} start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} style={styles.primaryAction}>
                  <TouchableOpacity onPress={_onLogin} style={styles.primaryActionTouch} activeOpacity={0.9}>
                    <Text fontSize={16} color="#FFFFFF" style={styles.primaryActionText}>
                      Login
                    </Text>
                  </TouchableOpacity>
                </LinearGradient>
              </View>

              <View style={styles.desktopHelperRow}>
                <NativeText style={styles.desktopHelperText}>New to Hubita?</NativeText>
                <TouchableOpacity onPress={() => navigation.navigate('RegisterScreen')} activeOpacity={0.85}>
                  <NativeText style={styles.desktopHelperLink}>Create your account</NativeText>
                </TouchableOpacity>
              </View>
            </View>
          </View>

          <ImageBackground source={rightImg} style={styles.publicRightPanel} imageStyle={styles.publicRightImage}>
            <LinearGradient
              colors={['rgba(27,42,78,0.92)', 'rgba(76,74,219,0.78)', 'rgba(204,88,227,0.62)']}
              start={{ x: 0, y: 0 }}
              end={{ x: 1, y: 1 }}
              style={styles.publicOverlay}
            >
              <View style={styles.publicTopAction}>
                <NativeText style={styles.publicTopActionText}>
                  Don't have an account yet?
                </NativeText>
                <TouchableOpacity
                  onPress={() => navigation.navigate('RegisterScreen')}
                  style={styles.secondaryAction}
                  activeOpacity={0.9}
                >
                  <NativeText style={styles.secondaryActionText}>
                    Register
                  </NativeText>
                </TouchableOpacity>
              </View>

              <View style={styles.publicHeroCopy}>
                <NativeText style={styles.publicHeroEyebrow}>Built for selfmanaging landlords</NativeText>
                <NativeText style={styles.publicHeroTitle}>
                  Everything your property needs.
                </NativeText>
                <NativeText style={styles.publicHeroTitle}>
                  One simple hub — always in your control.
                </NativeText>
                <NativeText style={styles.publicHeroText}>
                  Join Hubita to manage reminders, rent, documents and tenant activity in one secure place — giving you clarity, confidence and control over every part of your rental journey.
                </NativeText>

                <View style={styles.desktopHighlightList}>
                  {loginHighlights.map((item) => (
                    <View key={item} style={styles.desktopHighlightItem}>
                      <View style={styles.desktopHighlightDot} />
                      <NativeText style={styles.desktopHighlightText}>{item}</NativeText>
                    </View>
                  ))}
                </View>
              </View>
            </LinearGradient>
          </ImageBackground>
        </View>
      </View>
    );

  const loginContent = (
    <Container>
      <LeftSection>
        <FormContainer>
          <TouchableOpacity onPress={() => { navigation.push('Hello') }}>
            <ImageLogoWrapper source={LogoImg} />
          </TouchableOpacity>
          <Text fontSize={30} marginBottom={30} marginTop={10} color={Colors.light.gradientColor1} fontWeight={450}>
            Login to your{'\n'}existing account
          </Text>
          <TextInputComponent
            error={emailError}
            title={'Email Address'}
            onChangeText={(e) => {
              setEmail(e), setEmailError('');
            }}
            colored
          />
          <TextInputComponent
            error={passError}
            password
            maxLength={30}
            title={'Password'}
            renderRightComponent={true}
            onChangeText={(e) => {
              setPassword(e), setPassError('');
            }}
            colored
          />
          <TouchableWrapper onPress={() => navigation.navigate('ForgotPasswordScreen')}>
            <Text fontSize={20} color={Colors.light.purple} fontWeight={450}>
              Forgot Password?
            </Text>
          </TouchableWrapper>
          <Button onPress={_onLogin} childText={'Login'} alignSelf={'flex-end'} />
        </FormContainer>
      </LeftSection>
      <RightSection>
        <TopSection>
          {layoutType != 'phone' ? <>
            <Text fontSize={20} color={Colors.light.white} fontWeight={450}>
              Don't have an account yet?   {' '}
            </Text>
            <Button
              onPress={() => navigation.navigate('RegisterScreen')}
              type={'stripe'}

              childText={'Register'}
              color={Colors.light.white}
              width={105}
            />
          </> :
            <>
              <Text fontSize={18} color={Colors.light.text} fontWeight={450}>
                Don't have an account yet?  {' '}
              </Text>
              <Button
                onPress={() => navigation.navigate('RegisterScreen')}
                type={'stripe'}

                childText={'Register'}
                color={Colors.light.purple}
                width={105}
              />
            </>
          }

        </TopSection>
        {
          layoutType == 'phone' ? null :
            <>
              <ImageWrapper source={rightImg} />
              <GradientOverlay colors={['#7002BC90', '#3364F590']} start={{ x: 1, y: 0 }} end={{ x: 1, y: 1 }} />
            </>
        }
      </RightSection>
    </Container>
  );

  if (!userToken) {
    return (
      <View style={{ flex: 1, backgroundColor: '#F7F9FC' }}>
        <Header setDrawer={() => setDrawer(true)} />
        <View style={{ flex: 1 }}>
          {publicLoginContent}
        </View>
        <FooterLanding navigation={navigation} />
        <Modal
          isVisible={openDrawer}
          animationIn="slideInRight"
          animationOut="slideOutRight"
          animationInTiming={300}
          animationOutTiming={300}
          coverScreen={false}
          hasBackdrop={false}
          backdropOpacity={0}
          onBackdropPress={() => setDrawer(false)}
          style={{ margin: 0, width: '100%', right: 0 }}
        >
          <View
            style={{
              width: layoutType === 'phone' ? '100%' : '50%',
              height: '100%',
              position: 'absolute',
              right: 0,
              top: 0,
            }}
          >
            <MainDrawerMenu setDrawer={setDrawer} />
          </View>
        </Modal>
      </View>
    );
  }

  return (
    <>{loginContent}</>
  );
};

export default LoginScreen;

const styles = StyleSheet.create({
  publicShell: {
    flex: 1,
    paddingHorizontal: 28,
    paddingVertical: 26,
    backgroundColor: '#F7F9FC',
  },
  publicCard: {
    flex: 1,
    minHeight: 680,
    backgroundColor: '#FFFFFF',
    borderRadius: 20,
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: '#E6EAF2',
    shadowColor: '#101828',
    shadowOpacity: 0.08,
    shadowRadius: 24,
    shadowOffset: { width: 0, height: 12 },
    elevation: 4,
    flexDirection: 'row',
  },
  publicLeftPanel: {
    width: '48%',
    backgroundColor: '#FFFFFF',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 40,
    paddingVertical: 36,
  },
  publicFormCardInner: {
    width: '100%',
    maxWidth: 500,
    paddingVertical: 12,
  },
  publicTitle: {
    fontFamily: 'poppins',
    fontWeight: '700',
    fontSize: 44,
    lineHeight: 52,
    color: '#1B2559',
    maxWidth: 420,
  },
  publicSubtitle: {
    fontFamily: 'roboto-light',
    fontSize: 17,
    lineHeight: 28,
    color: '#667085',
    marginTop: 14,
    maxWidth: 430,
  },
  mobilePublicTitle: {
    fontSize: 34,
    lineHeight: 42,
    color: '#1E2A4A',
  },
  mobilePublicSubtitle: {
    fontSize: 16,
    lineHeight: 26,
  },
  publicInputsWrap: {
    marginTop: 22,
    gap: 12,
  },
  publicFooterRow: {
    marginTop: 20,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  forgotText: {
    fontFamily: 'poppins-medium',
  },
  forgotLinkWrap: {
    alignSelf: 'flex-start',
    marginTop: 4,
  },
  primaryAction: {
    minWidth: 140,
    height: 54,
    borderRadius: 14,
    overflow: 'hidden',
    shadowColor: '#4258DB',
    shadowOpacity: 0.24,
    shadowRadius: 14,
    shadowOffset: { width: 0, height: 8 },
    elevation: 3,
  },
  primaryActionTouch: {
    minWidth: 140,
    height: 54,
    paddingHorizontal: 28,
    justifyContent: 'center',
    alignItems: 'center',
  },
  primaryActionMobile: {
    width: '100%',
    marginTop: 10,
  },
  primaryActionText: {
    fontFamily: 'poppins-medium',
  },
  publicRightPanel: {
    width: '52%',
    minHeight: 680,
    justifyContent: 'space-between',
    backgroundColor: '#25125F',
  },
  publicRightImage: {
    resizeMode: 'cover',
  },
  publicOverlay: {
    flex: 1,
    paddingHorizontal: 38,
    paddingVertical: 34,
    justifyContent: 'space-between',
  },
  publicTopAction: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  publicTopActionText: {
    fontFamily: 'poppins-medium',
    fontSize: 20,
    lineHeight: 28,
    color: '#FFFFFF',
    marginRight: 18,
  },
  secondaryAction: {
    height: 50,
    paddingHorizontal: 28,
    borderRadius: 14,
    borderWidth: 2,
    borderColor: 'rgba(255,255,255,0.9)',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255,255,255,0.08)',
  },
  secondaryActionText: {
    fontFamily: 'poppins-medium',
    fontSize: 16,
    lineHeight: 22,
    color: '#FFFFFF',
  },
  publicHeroCopy: {
    maxWidth: 480,
    paddingBottom: 12,
  },
  publicHeroEyebrow: {
    fontFamily: 'poppins-medium',
    fontSize: 14,
    lineHeight: 20,
    color: '#D5D9FF',
    marginBottom: 14,
  },
  publicHeroTitle: {
    fontFamily: 'poppins',
    fontWeight: '700',
    fontSize: 42,
    lineHeight: 52,
    color: '#FFFFFF',
  },
  publicHeroText: {
    fontFamily: 'roboto-light',
    fontSize: 17,
    lineHeight: 28,
    color: 'rgba(255,255,255,0.9)',
    marginTop: 16,
  },
  desktopHighlightList: {
    marginTop: 28,
  },
  desktopHighlightItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 14,
  },
  desktopHighlightDot: {
    width: 10,
    height: 10,
    borderRadius: 999,
    backgroundColor: '#CC58E3',
    marginTop: 9,
    marginRight: 12,
  },
  desktopHighlightText: {
    flex: 1,
    fontFamily: 'roboto-light',
    fontSize: 16,
    lineHeight: 24,
    color: '#FFFFFF',
  },
  desktopHelperRow: {
    marginTop: 18,
    flexDirection: 'row',
    alignItems: 'center',
  },
  desktopHelperText: {
    fontFamily: 'roboto-light',
    fontSize: 15,
    lineHeight: 22,
    color: '#667085',
  },
  desktopHelperLink: {
    fontFamily: 'poppins-medium',
    fontSize: 15,
    lineHeight: 22,
    color: '#4258DB',
    marginLeft: 8,
  },
  mobilePublicWrap: {
    flex: 1,
    paddingHorizontal: 18,
    paddingTop: 18,
    paddingBottom: 24,
    backgroundColor: '#F7F9FC',
  },
  mobileFormCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#E6EAF2',
    padding: 22,
    shadowColor: '#101828',
    shadowOpacity: 0.06,
    shadowRadius: 18,
    shadowOffset: { width: 0, height: 10 },
    elevation: 2,
  },
  formFieldSpace: {
    marginTop: 10,
  },
  mobileInputBlock: {
    marginTop: 22,
  },
  mobileSecondaryAction: {
    width: '100%',
    height: 50,
    marginTop: 12,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: '#D9E3FB',
    backgroundColor: '#F8FBFF',
    alignItems: 'center',
    justifyContent: 'center',
  },
  mobileSecondaryActionText: {
    fontFamily: 'poppins-medium',
    fontSize: 16,
    lineHeight: 20,
    color: '#1B2A4E',
  },
  mobileHighlightList: {
    marginTop: 18,
  },
  mobileHighlightItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 12,
  },
  mobileHighlightDot: {
    width: 8,
    height: 8,
    borderRadius: 999,
    backgroundColor: '#CC58E3',
    marginTop: 8,
    marginRight: 10,
  },
  mobileHighlightText: {
    flex: 1,
    fontFamily: 'roboto-light',
    fontSize: 14,
    lineHeight: 22,
    color: '#667085',
  },
  mobileRegisterRow: {
    marginTop: 18,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  mobileRegisterText: {
    fontFamily: 'poppins-medium',
    marginLeft: 6,
  },
});
